import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { RadioGroupWithLabel } from "../../../common/RadioGroup";
import { getExcessiveShipmentList } from "../../../PickupProcessing/util";
import CustomTextField from "../../../common/CustomTextField";
import appConstants from "../../../../../../../../appConstants";
import { MAX_VALUE_CONSTRAINTS } from "../../../common/constants";
import Collapse from "@material-ui/core/Collapse";
const styles = (theme) => ({
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  infoText: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    opacity: 0.8,
  },
  fullWidth: { width: "100%" },
  headerStyle: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    letterSpacing: 1.5,
    marginTop: 12,
    display: "block",
  },
  detailsColumnWise: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  rowDescription: {
    display: "flex",
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    marginTop: 8,
    fontWeight: 500,
  }
});

const ExcessiveLength = ({
  classes,
  errorInfo,
  editInfo,
  handleChange,
  maxAllowedTrailerLength,
  }) => {
  return (
    <>
      <RadioGroupWithLabel
        rowLabel="EXCESSIVE LENGTH"
        rowDescription="Does the Pro have Excessive length ?"
        onChange={handleChange("isExcessiveLength")}
        options={getExcessiveShipmentList().filter(
          (option) =>
            option.value !== appConstants.EXCESSIVE_SHIPMENT.CAN_NOT_SEE
        )}
        value={editInfo.isExcessiveLength}
        customClasses={classes}
      />
      <Collapse
        in={editInfo.isExcessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES}
        timeout="auto"
        unmountOnExit
      >
        <CustomTextField
          className={classes.fullWidth}
          id="excessiveLength"
          handleChange={handleChange("excessiveLength")}
          value={editInfo.excessiveLength}
          error={errorInfo.excessiveLength}
          label="Pro Length (Feet)"
          inputProps={{
            max: MAX_VALUE_CONSTRAINTS.DELIVERY_PRO_FORM.EXCESSIVE_LENGTH,
            focus: true
          }}
          type="number"
        />
        <br />
        <span className={classes.infoText}>
          {!Boolean(errorInfo.excessiveLength) &&
            `Pro must be 8 feet (or) less than or equal to trailer length(${maxAllowedTrailerLength}).`}
        </span>
      </Collapse>
    </>
  );
};

export default withStyles(styles)(ExcessiveLength);
